/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sw-update-prompt[_ngcontent-%COMP%]{background-color:#add8e6;border:1px solid #000;width:100vw;height:20px;position:fixed;bottom:0;text-align:center}.fakelink[_ngcontent-%COMP%]{cursor:pointer;color:#00f;text-decoration:underline}.fakelink[_ngcontent-%COMP%]:hover{text-decoration:none}"];
export { styles as styles };
